const { initDefaultSelect2 } = require('../../general/functions');

const initExportScripts = () => {
  var scheduleIDSelected = null;
  $('#importType').on('change', function (e) {
    e.preventDefault();

    let flag = false;
    var value = $(this).val();
    $('#wrapperScheduleID').hide();

    console.log('value: ', value);
    switch (value) {
      case 'b8018ae69c':
        // Expo
        scheduleIDSelected = value;
        flag = true;
        break;

      case '1f64078aab':
        // Info Session
        scheduleIDSelected = value;
        flag = true;
        break;

      case '9712c02c831':
        // School Fair
        scheduleIDSelected = value;
        flag = true;
        break;
      default:
        scheduleIDSelected = null;
        flag = false;
        break;
    }

    if (flag) {
      $('#selectScheduleID').attr('required', false);
      $('#wrapperScheduleID').show();
      initDefaultSelect2(
        true,
        {
          endpoint: `${BASE_URL}Select2Controller/getScheduler`,
          data: { sourceType: scheduleIDSelected },
        },
        '#selectScheduleID',
        $('#wrapperScheduleID'),
        $(this).data('placeholder'),
        false,
        false,
        true,
        Infinity,
        false,
        {
          show: true,
          content: 'No results found.',
        },
        true,
        function (data) {
          if (!data.id) {
            return data.text;
          }

          return `
                    <span class="fs-7 fw-bold">
                        ${data.text}
                        <span class="ml-2 fs-8 label label-sm label-inline label-primary text-white fw-bolder">${data.beauty_date}</span>
                        <span class="ml-2 fs-8 label label-sm label-inline label-${data.status == 'ACTIVE' ? 'success' : 'danger'} text-white fw-bolder">${data.status}</span>
                    </span>
                `;
        },
        function (data) {
          if (!data.id) {
            return data.text;
          }
          return `
                    <span class="fs-7 fw-bold">
                        ${data.text}
                        <span class="ml-2 fs-8 label label-sm label-inline label-primary text-white fw-bolder">${data.beauty_date}</span>
                        <span class="ml-2 fs-8 label label-sm label-inline label-${data.status == 'ACTIVE' ? 'success' : 'danger'} text-white fw-bolder">${data.status}</span>
                    </span>
                `;
        }
      );
    } else {
      $('#selectScheduleID').attr('required', true);
      $('#wrapperScheduleID').hide();
    }
  });
};

export { initExportScripts };
